
<fusioncharts
[width]="width"
[height]="height"
[type]="type"
[dataSource]="dataSource"
>
</fusioncharts>
